export default {
    user(state) {
        return state.user;
    },
    company(state) {
        return state.company;
    },
    role(state) {
        return state.role;
    },
    permissions(state) {
        return state.permissions || [];
    },
    hasPermission: (state) => (permission) => {
        return (state.permissions || []).includes(permission);
    },
};
